import { FindMeetingTimesRequestDataPoint } from '../store/schema/DiagnosticsLogState';
import { getDiagnosticsLogState } from '../store/store';
import { action, mutator } from 'satcheljs';

const LOGGER_NAME = 'Cas';

export function logFindMeetingTimesRequestDiagnostics(datapoint: FindMeetingTimesRequestDataPoint) {
    if (!datapoint) {
        return;
    }
    const logger = getDiagnosticsLogState().loggers.get(LOGGER_NAME);
    logger.datapoints.unshift(datapoint);
}

export const selectFindMeetingTimesDiagnosticsItem = action(
    'SelectFindMeetingTimesDiagnosticsItem',
    (key: string | number) => ({ key })
);

mutator(selectFindMeetingTimesDiagnosticsItem, requestId => {
    const logger = getDiagnosticsLogState().loggers.get(LOGGER_NAME);
    const filtered = logger.datapoints.filter(dp => dp.requestId == requestId.key);
    logger.selected = filtered.length > 0 ? filtered[0] : null;
});
